import { QueryClient } from '@tanstack/vue-query';

const queryClient = new QueryClient();

// theses keys can be a function or a simple array
export const queryKeys = {
  AUTH: {
    LOGIN: ['AUTH', 'LOGIN'],
    LOGOUT: ['AUTH', 'LOGOUT'],
    STATUS: ['AUTH', 'STATUS'],
  },
};

export default queryClient;
